<template>
  <div class="fd-dm-filters-block">
    <ScreenLoader class="predefined-filter-data" v-if="showLoader" />
    <div v-if="!showLoader" class="carousel-wrapper fd-dm-filters">
      <div class="fd-dm-filters__head">
        <p class="recent-activity">Pre-Defined Filters</p>
        <div v-if="filterSummaries.length > 0" class="fd-dm-filters__nav">
          <span class="fd-dm-filters__range">{{ filterRangeLabel }}</span>
          <v-btn
            icon
            class="fd-dm-filters__arrow"
            :disabled="carouselIndex === 0"
            @click="carouselIndex--"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            icon
            class="fd-dm-filters__arrow"
            :disabled="carouselIndex >= lastCarouselIndex"
            @click="carouselIndex++"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
      <v-carousel
        v-if="filterSummaries.length > 0"
        class="predefined-filter-carousel"
        v-model="carouselIndex"
        hide-delimiters
        :show-arrows="false"
        height="auto"
      >
        <v-carousel-item
          v-for="(pair, index) in chunkArray(filterSummaries, chunkSize)"
          :key="index"
        >
          <v-row no-gutters>
            <v-col
              v-for="filter in pair"
              :key="filter.ID"
              :cols="Math.floor(12 / chunkSize)"
            >
              <v-sheet class="sheet" @click="getFilterDetailTopage(filter)">
                <v-card
                  link
                  class="v-card-asset fd-dm-filter-card"
                  :class="{ 'fd-dm-filter-card--selected': isSelectedFilter(filter) }"
                >
                  <v-card-title class="assets_name">
                    <span class="fd-dm-filter-card__name">{{ filter.name }}</span>
                    <v-icon
                      v-if="isSelectedFilter(filter)"
                      class="fd-dm-filter-card__refresh"
                      size="18"
                    >mdi-refresh</v-icon>
                  </v-card-title>
                  <v-card-text class="assets-data">
                    <div class="test-fields-container container-top">
                      <div class="test-field-entry go-link">
                        Assets
                        <span>{{
                          filter.assets ? filter.assets.length : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        Fields
                        <span>{{
                          filter.fields ? filter.fields.length : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        Wells
                        <span>{{
                          filter.wells ? filter.wells.length : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        Samples
                        <span>{{
                          filter.samples ? filter.samples : 0
                        }}</span>
                      </div>
                    </div>
                    <div class="test-fields-container pb-0 mb-0">
                      <div class="test-field-entry">
                        <p class="test-name">Compositions</p>
                        <span>{{
                          filter.compositions ? filter.compositions : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        <p class="test-name">Separator</p>
                        <span>{{
                          filter.separatorTests ? filter.separatorTests : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        <p class="test-name">CCE Tests</p>
                        <span>{{ filter.cceTests ? filter.cceTests : 0 }}</span>
                      </div>
                      <div class="test-field-entry">
                        <p class="test-name">Viscosity Tests</p>
                        <span>{{
                          filter.viscosityTests ? filter.viscosityTests : 0
                        }}</span>
                      </div>
                      <div class="test-field-entry">
                        <p class="test-name">DL Tests</p>
                        <span>{{ filter.dlTests ? filter.dlTests : 0 }}</span>
                      </div>
                      <div class="test-field-entry">
                        <p class="test-name">CVD Tests</p>
                        <span>{{ filter.cvdTests ? filter.cvdTests : 0 }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-sheet>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>

      <div v-if="filterSummaries.length === 0" class="mb-3">
        <p>No filters found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../axiosInterceptor";
import ScreenLoader from "../layout/Loaders/ScreenLoader.vue";
import { mapGetters } from "vuex";

export default {
  name: "PreDefinedFilters",
  components: {
    ScreenLoader,
  },
  data: () => ({
    filterSummaries: [],
    showLoader: false,
    timeoutMessage: "",
    carouselIndex: 0,
    chunkSize: 4, // Default chunk size
    selectedFilterId: null,
  }),
  props: {
    drawerValue: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters("tenantId", ["getSelectedTenant"]),
    lastCarouselIndex() {
      return Math.max(0, Math.ceil(this.filterSummaries.length / this.chunkSize) - 1);
    },
    selectedFilterKey() {
      return String(this.selectedFilterId ?? localStorage.getItem("lastFilterId") ?? "");
    },
    filterRangeLabel() {
      if (!this.filterSummaries.length) return "";
      const start = this.carouselIndex * this.chunkSize + 1;
      const end = Math.min(
        (this.carouselIndex + 1) * this.chunkSize,
        this.filterSummaries.length
      );
      return `${start}-${end} of ${this.filterSummaries.length}`;
    },
  },
  methods: {
     handleResize() {
      this.chunkSize = this.calculateChunkSize();
    },
    isSelectedFilter(filter) {
      const selected = this.selectedFilterKey;
      return selected !== "" && String(filter?.ID ?? "") === selected;
    },
    restoreSelectedFilter() {
      const lastId = localStorage.getItem("lastFilterId");
      if (lastId) this.selectedFilterId = lastId;
    },
    resetCardSelection(){
      this.selectedFilterId = "";
    },
    chunkArray(array, size) {
      const chunks = [];
      for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
      }
      return chunks;
    },
    calculateChunkSize() {
      if (window.innerWidth >= 1300) return 4; // Large screens
      if(window.innerWidth >= 1100) return 3; // Large screens
      if(window.innerWidth >= 850) return 2;
      if (window.innerWidth >= 320) return 1; // Tablets
    },
    getFilterDetailTopage(filter) {
      this.selectedFilterId = filter.ID;
      localStorage.setItem("lastFilterId", filter.ID); // Set selected filter id into local storage as lastFilterId
      this.$emit("getFilterDetailTopage", filter);
    },
    callApi() {
      this.getFilterSummaries();
    },
    CardSelection(filterData){
      this.selectedFilterId = filterData.ID;
    },
    getFilterSummaries() {
      this.showLoader = true;
      this.filterSummaries = [];
      this.timeoutMessage = "";

      api
        .get("public/api/filters/summary")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.filterSummaries = response.data.data.filterWithSummary.filter(
              (summary) => summary.name
            );
            this.$emit('showFilterDiv', this.filterSummaries.length > 0 ? true : false);
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
      this.timeoutMessage = "Error in fetching filters summary";
    }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
          this.restoreSelectedFilter();
        });
    },
  },
  watch: {
  '$route'(to, from) {
    if (to.fullPath !== from.fullPath) {
      this.getFilterSummaries();
    }
  }
},
  mounted() {
    this.chunkSize = this.calculateChunkSize();
    window.addEventListener("resize", this.handleResize);
    this.getFilterSummaries();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
